import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showNavHeaders: false
};

const navbarSlice = createSlice({
    name: 'NavBar',
    initialState,
    reducers: {
        showNavHeadersAction: (state, action) => {
            state.showNavHeaders = true;
        },
        hideNavHeadersAction: (state, action) => {
            state.showNavHeaders = false;
        }
    },
});

export const {
    showNavHeadersAction,
    hideNavHeadersAction
} = navbarSlice.actions;

export default navbarSlice.reducer;
